import {
  AggregateMap as GlobalAggregateMap,
  AggregateReduce as GlobalAggregateReduce,
} from './common.js';

export const DrawingResponseSelectionsReducer = () => [];

export const DrawingResponseSelectionsAggregator = () => [];

export default {
  AggregateMap: GlobalAggregateMap(DrawingResponseSelectionsAggregator),
  AggregateReduce: GlobalAggregateReduce(DrawingResponseSelectionsReducer),
};
